import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import gojo_bg from '../assets/pfp.webp';
import { Button } from '@mui/material';

const Hero = () => {

  // Function to download the resume
  const handleDownloadResume = () => {
    const resumeUrl = "/assets/resume.pdf"; // Directly reference the public folder
    const link = document.createElement("a");
    link.href = resumeUrl;
    link.download = "Abhiram_Gargeya.pdf"; // Set the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Function to scroll to the contact section
  const handleScrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex flex-col sm:grid sm:grid-cols-2 max-w-[1400px] h-[calc(100vh-80px)] mx-auto py-6 px-4 gap-8 sm:gap-0 sm:items-center sm:justify-center">
  
      {/* Image Container */}
      <div className="w-full flex justify-center my-10 sm:mb-0">
        <div className="w-64 h-64 sm:w-72 sm:h-72 lg:w-80 lg:h-80 rounded-full overflow-hidden flex items-center justify-center border-4 border-[#9666ad] shadow-lg bg-white">
          <img src={gojo_bg} alt="Gojo" className="w-full h-full object-cover" />
        </div>
      </div>

      {/* Text Section */}
      <div className="flex flex-col items-center sm:items-start justify-center text-center sm:text-left space-y-6">
        <div className="text-[#703D99] text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
          Hello Everyone!<br />
          <span>Abhi </span>here<br />
          <span>I'm a </span> 
          <TypeAnimation 
            className="text-green-600"
            sequence={[
              " Developer", 1000,
              " Gamer", 1000,
              " Drummer", 1000,
              " Biker", 1000,
              " Athlete", 1000
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
          />
        </div>

        <div className="flex flex-row space-x-4">
          <Button variant="contained" className="bg-[#703D99] hover:bg-[#5A2E7E] text-white px-6 py-2 rounded-md shadow-md" onClick={handleDownloadResume}>
            Resume
          </Button>
          <Button variant="outlined" className="border-[#703D99] text-[#703D99] hover:bg-[#703D99] hover:text-white px-6 py-2 rounded-md shadow-md" onClick={handleScrollToContact}>
            Contact
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
